import Modal from "./modal.container";

export default Modal;
